import Form from 'components/Form';

import { Fragment } from 'react';
import { Grid } from '@mui/material';

import RowContainer from '../components/RowContainer';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import { Stack } from '@mui/system';
import RowContent from '../components/RowContent';
import RowContentPre from './components/RowContent';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const scheduled = [
  {
    label: '導管檢查',
    key: 'recommendation_schedule.checked1',
  },
  {
    label: '超音波',
    key: 'recommendation_schedule.checked2',
  },
  {
    label: '壓力測試',
    key: 'recommendation_schedule.checked3',
  },
  {
    label: '心臟超音波',
    key: 'recommendation_schedule.checked4',
  },
  {
    label: '血流檢測',
    key: 'recommendation_schedule.checked5',
  },
  {
    label: '核磁共振',
    key: 'recommendation_schedule.checked6',
  },
];

const consults1 = [
  {
    label: '病例管理',
    key: 'recommendation_consults.checked1',
  },
  {
    label: '物理治療',
    key: 'recommendation_consults.checked2',
  },
  {
    label: '職能治療',
    key: 'recommendation_consults.checked3',
  },
  {
    label: '腸胃科',
    key: 'recommendation_consults.checked4',
  },
  {
    label: '心臟科',
    key: 'recommendation_consults.checked5',
  },
  {
    label: '神經科',
    key: 'recommendation_consults.checked6',
  },
  {
    label: '腎臟科',
    key: 'recommendation_consults.checked7',
  },
  {
    label: '傷口護理',
    key: 'recommendation_consults.checked8',
  },
];

const consults2 = [
  {
    label: '骨科',
    key: 'recommendation_consults.checked9',
  },
  {
    label: '心理科',
    key: 'recommendation_consults.checked10',
  },
  {
    label: '肺科',
    key: 'recommendation_consults.checked11',
  },
  {
    label: '外科',
    key: 'recommendation_consults.checked12',
  },
];

const discharge = [
  {
    label: '回家',
    key: 'recommendation_discharge.checked1',
  },
  {
    label: '居家護理',
    key: 'recommendation_discharge.checked2',
  },
  {
    label: '輔助生活設施',
    key: 'recommendation_discharge.checked3',
  },
  {
    label: '療養院',
    key: 'recommendation_discharge.checked4',
  },
  {
    label: '復健',
    key: 'recommendation_discharge.checked5',
  },
];

const Recommendation = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="R (Recommendation, 建議)" />
      <RowContainer
        xs={12}
        sx={{ margin: '20px 0px 30px 0px', marginLeft: '-25px' }}
      >
        <RowContentPre title="預定程序" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            {scheduled.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContentPre>
        <RowContent title="會診" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            {consults1.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            {consults2.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="出院安排" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            {discharge.map((v, i) => {
              return (
                <Grid item xs={1.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Recommendation;
